export default __webpack_public_path__ + "static/media/squirrel.99b823eb.png";